import React from 'react'
import cx from 'classnames'
import * as R from 'ramda'
import { t } from 'ttag'

import styles from './FormFieldLabel.module.scss'

export const FormFieldLabel = ({
  className = undefined,
  id,
  label,
  name,
  size = 'small',
  isCheckbox,
  isDisabled,
  isEditor,
  isHorizontalOrientation,
  isOptional,
  isScore,
  isScoreActive,
  isSwitch,
}) => {
  const Component = isEditor ? 'span' : 'label'

  return (
    <div
      className={cx(styles.description, {
        [styles.horizontal]: isHorizontalOrientation,
        [styles.checkbox]: isCheckbox,
        [styles.score]: isScore,
        [styles.active]: isScoreActive,
        [styles.switch]: isSwitch,
      })}
    >
      <Component
        className={cx(styles.label, {
          [styles.size]: Boolean(size),
          [styles[size]]: Boolean(size),
          [styles.disabled]: R.and(isHorizontalOrientation, isDisabled),
          [className]: Boolean(className),
        })}
        {...(isEditor ? { id: id ?? name } : { htmlFor: id ?? name })}
      >
        {label}
      </Component>
      {isOptional ? (
        <span className={styles.optional}>{t`Optional`}</span>
      ) : null}
    </div>
  )
}
